// Which CSRF token web/src/api/client.js sends. Pure, for node --test
// (test/web/csrf-token.test.js); the cookie read is injected.
//
// The token GET /api/me handed over is held in memory and preferred. Before it arrives,
// the readable `crm_csrf` cookie is the fallback, so a mutation fired during a fresh page
// load still carries one.
//
// EXCEPT AFTER A SIGN-OUT IN THIS TAB (ruling R8). Logout destroys the session but does
// not clear `crm_csrf`, and the next person's sign-in on this desk overwrites it with
// THEIR token. A tab that fell back to the cookie then would send the next person's valid
// token on a stale timer's save, and a draft never saved before would be CREATED under
// them with the previous agent's text. So once a token has been held and then cleared,
// nothing is sent until a real token is held again: the server refuses the mutation
// `403 CSRF_TOKEN_INVALID`, the identity check re-reads GET /api/me, sees the new person,
// and reloads the tab.

/**
 * @param {() => string|null} readCookie  The `crm_csrf` cookie's value, or null.
 * @returns {{ set(token): void, current(): string|null }}
 */
export function createCsrfTokenState(readCookie) {
  let held = null;
  // True once a held token was cleared: the cookie may now be someone else's.
  let signedOut = false;

  return {
    set(token) {
      if (token) {
        held = token;
        signedOut = false;
        return;
      }
      if (held) signedOut = true;
      held = null;
    },
    current() {
      if (held) return held;
      if (signedOut) return null;
      return readCookie() ?? null;
    },
  };
}
